module.exports = __webpack_public_path__ + "static/img/total_shop.67c9ac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/total_shop.png
// module id = QAHt
// module chunks = 0